<template>
  <div>
    <v-container>
      <v-flex xs12 class="text-xs-center">
          <Propeller :adChoice="1"/>
      </v-flex>
    </v-container>
    
    <v-container class="lightbox-container">
      <component :is="dynamicLightboxComponent" v-bind="dynamicLightboxProps"></component>
    </v-container>
    <footer>
    <v-container>
      <v-flex xs12 class="text-xs-center" style="clear:left;">
        <!-- <component :is="dynamicAdComponent" v-bind="dynamicAdProps"></component> -->
      </v-flex>
    </v-container>
    </footer>
  </div>
</template>

<script>
  import axios from "axios";
  import lambda from "../lambda";
  import config from "../config";
  import Lightbox from "vue-picture-swipe";
  import Propeller from "./ads/Propeller";

  export default {
    name: "ThumbnailGrid",
  
    components: {
      Lightbox,
      Propeller
    },
  
    props: ["id"],
  
    data() {
      return {
        imageGalleryMapping: [],
        dynamicAdComponent: null,
        dynamicAdProps: null,
        dynamicLightboxComponent: null,
        dynamicLightboxProps: null,
        options: {
          fullscreenEl: false,
          zoomEl: false,
          history: true,
          shareButtons: [{
            id: "download",
            label: "Download image",
            url: "{{raw_image_url}}",
            download: true
          }]
        }
      };
    },
  
    mounted() {
      this.getFilesFromS3().then(() => {
        let getThumb = true;
        let getFullSize = false;
        let vm = this;
        return Promise.all([
          //this.getDownloadSignedUrls(getThumb),
          //this.getDownloadSignedUrls(getFullSize)
        ]).then(function(results) {
          vm.createDynamicLightboxProps();
        });
      });
    },
  
    methods: {
      createDynamicLightboxProps: function() {
        return new Promise((resolve, reject) => {
          let temp = [];
          for (let obj of this.imageGalleryMapping) {
            temp.push(
              Object({
                thumbnail: obj.Thumb,
                src: obj.Src,
                h: obj.Src.match("vh_(.*)_vw_(.*)_sz") ?
                  obj.Src.match("vh_(.*)_vw_(.*)_sz")[1] :
                  "600",
                w: obj.Src.match("vh_(.*)_vw_(.*)_sz") ?
                  obj.Src.match("vh_(.*)_vw_(.*)_sz")[2] :
                  "800"
              })
            );
          }
          this.dynamicLightboxProps = Object({
            items: temp,
            options: this.options
          });
          this.dynamicLightboxComponent = "Lightbox";
          
          this.dynamicAdProps = Object({adChoice: 1})
          this.dynamicAdComponent = "RevenueHits"
        })
      },
  
      getFilesFromS3: function() {
        return new Promise((resolve, reject) => {
          axios
            .get(`${config.AWS_LAMBDA_GET_LIST_OF_FILES_ENDPOINT}${this.id}`)
            .then(response => {
              //loop through the files from s3
              for (let content of response.data.Contents) {
                let isPaired = response.data.Contents.filter(
                  x => x.Key.substring(0, 25) == content.Key.substring(0, 25)
                );
                if (isPaired.length == 2)
                  if (content.Key.indexOf("-thumbnail-") !== -1) {
                    //make sure the thumbnails have a corresponding fullsize image
                    //if you find the thumbnail key, push it into the thumbnail array
                    let bucketName = "uppin-upload-stage-assets"
                    let cloudFrontDomain = "cdn.imgsurv.com"
                    let key = content.Key
                    let thumbTargetURL = `https://${cloudFrontDomain}/${key}`
                    
                    key = content.Key.replace("-thumbnail","")
                    let fullTargetURL = `https://${cloudFrontDomain}/${key}`
                    this.imageGalleryMapping.push(
                      new Object({
                        Key: content.Key,
                        Thumb: thumbTargetURL,
                        Src: fullTargetURL
                      })
                    );
                  }
              }
            })
            .then(() => {
              resolve();
            })
            .catch(e => {
              reject(e);
            });
        });
      },

      getDownloadSignedUrls: function(getThumb) {
        var vm = this;
        return new Promise((resolve, reject) => {
          var promises = vm.imageGalleryMapping.map(function(k) {
            if (!getThumb) {
              k.Key = k.Key.replace("-thumbnail", "");
            }
            return vm.downloadImage(k.Key);
          });
          resolve(Promise.all(promises));
        });
      },
  
      downloadImage: function(fileKey) {
        var vm = this;
        return new Promise((resolve, reject) => {
          lambda
            .getSignedURLDownload(fileKey)
            .then(url => {
              for (let image of vm.imageGalleryMapping) {
                if (image.Key.substring(0, 30) == fileKey.substring(0, 30)) {
                  if (fileKey.indexOf("-thumbnail") > -1) {
                    image.Thumb = url;
                  } else {
                    image.Src = url;
                  }
                  return url;
                }
              }
            })
            .then(() => {
              resolve();
            })
            .catch(err => {
              console.log("failed to get signed");
              console.log(err);
            });
        });
      }
    }
  };
</script>

<style>
figure{
  float: left;
  margin: 0px !important;
}

figure>a>img{
  height: 100px;
  width: 100px;
}

form>div>div>img {
    width: 120px;
    height: 120px;
}

.lightbox-container{
  padding: 0px !important;
  padding-left: 1% !important;
}

</style>


// WEBPACK FOOTER //
// src/components/ThumbnailGrid.vue